import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ScheduleReminderFormFields } from './schedule-reminder.formly-fields';
import { NewReminderForm } from 'app/models/dto/new-reminder.model';
import { FormlyFormOptions } from '@ngx-formly/core';
import { Reminder } from 'app/models/dto/reminder.model';

@Component({
  selector: 'app-schedule-reminder-form',
  templateUrl: './schedule-reminder-form.component.html',
  styleUrls: ['./schedule-reminder-form.component.scss']
})
export class ScheduleReminderFormComponent implements OnChanges, OnInit {

  @Output() newReminder = new EventEmitter<NewReminderForm>();
  @Output() rescheduleReminder = new EventEmitter<NewReminderForm>();
  @Output() newDateSelected = new EventEmitter<Date>();
  @Output() cancel = new EventEmitter();
  @Input() startDate: string;
  @Input() reminder: Reminder;

  form = new UntypedFormGroup({});
  scheduleReminderFormFields = new ScheduleReminderFormFields();
  fields = this.scheduleReminderFormFields.getFields;
  eventDate: string | Date;
  model: {
    date: Date;
    hour: string | number;
    minutes: string | number;
    meridiem: string;
    action: string | null;
    reason: string | null;
  };
  options: FormlyFormOptions = {};

  constructor() {}

  ngOnInit() {
    this.refreshModel(this.startDate ? this.startDate : new Date());
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.startDate) {
      this.refreshModel(this.startDate);
    }
    if (changes.reminder) {
      this.refreshModel(this.reminder.expires);
    }
  }

  refreshModel(date: string | Date) {
    this.eventDate = new Date(date);
    const hours = this.eventDate.getHours(),
      minutes = this.eventDate.getMinutes();
    this.model = {
      date: this.eventDate,
      hour: hours > 12 ? hours - 12 : hours,
      minutes: minutes < 10 ? '0'.concat(minutes.toString()) : minutes,
      meridiem: hours >= 12 ? 'pm' : 'am',
      action: this.reminder?.action || this.model?.action || null,
      reason: this.reminder?.reason || this.model?.reason || null,
    };
  }

  onSubmit() {
    const reminderObject = {
      expires: this.formatDateToTimestamp(),
      reason: this.model.reason ? this.model.reason : '',
      action: this.model.action
    };
    if (!this.reminder) {
      this.newReminder.emit(reminderObject);
    } else {
      this.rescheduleReminder.emit(reminderObject);
    }
    this.resetModel();
  }

  closeNewReminder() {
    this.cancel.emit();
    this.resetModel();
  }

  resetModel() {
    if (this.options.resetModel) {
      this.options.resetModel();
    }
  }

  change(event: any)  {
    if (event.date) {
      this.newDateSelected.emit(event.date);
    }
  }

  formatDateToTimestamp() {
    // eslint-disable-next-line max-len
    const date = new Date(`${this.model.date.toDateString()} ${this.model.hour}:${this.model.minutes} ${this.model.meridiem.toUpperCase()}`);
    return Math.round((date).getTime() / 1000);
  }
}
